import $ from 'jquery'
const numberInputs = {
  num: 1,
  init() {
    this.setInputs();
    this.addEvents()
  },
  setInputs() {
    const inputWraps = document.querySelectorAll(
      '.jsCustomNumberInput',
    ) as NodeListOf<HTMLElement>;

    inputWraps.forEach((item) => {
      const plus = item.querySelector('.jsPlus') as HTMLElement;
      const minus = item.querySelector('.jsMinus') as HTMLInputElement;
      const input = item.querySelector('.jsNumberInput') as HTMLInputElement;
      const btn = item.querySelector('.jsQtyBtn') as HTMLInputElement;
      plus?.addEventListener('click', () => {
        this.num++;
        input.value = this.num.toString();

      });

      minus?.addEventListener('click', () => {
        if (this.num > 0) {
          this.num--;
          input.value = this.num.toString();

        }
      });
      btn?.addEventListener('click', () => {
        setTimeout(() => {
          this.num = 1;
          input.value = '1';
        }, 500)
      });
    });
  },
  addEvents() {
    const inputWraps = document.querySelectorAll(
      '.jsCustomNumberInput',
    ) as NodeListOf<HTMLElement>;
    if (inputWraps.length) {
      window.addEventListener('resetQty', () => {
        inputWraps.forEach((item) => {
          const input = item.querySelector(
            '.jsNumberInput',
          ) as HTMLInputElement;
          this.num = 1
          input.value = '1';
        });
      });


    }
  },
};

export default numberInputs;